import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICamara } from 'modelos/src';
import { CameraPlayerComponent } from '../camera-player/camera-player.component';

export interface CameraStream {
  camara: ICamara;
  canal: string;
  /** Si está seteado → playback (record), si no → live. */
  recordDate?: string;
  /** Legacy: lo usaban consumers viejos pa loading manual. Ya no se llena
   * desde acá — el player hace todo. Lo dejamos opcional para no romper
   * shape externo. */
  streamUrl?: string;
  tunnel?: boolean;
  loading?: boolean;
  loadingTimedOut?: boolean;
  error?: boolean;
  errorMessage?: string;
}

@Component({
  selector: 'app-multi-camera-stream',
  standalone: true,
  imports: [CommonModule, CameraPlayerComponent],
  templateUrl: './multi-camera-stream.component.html',
  styleUrls: ['./multi-camera-stream.component.scss'],
})
export class MultiCameraStreamComponent {
  @Input() streams: CameraStream[] = [];
  @Input() gridColumns: number = 2;
  @Input() popupMapa: boolean = false;

  @Output() streamClick = new EventEmitter<CameraStream>();

  public onStreamClick(stream: CameraStream): void {
    this.streamClick.emit(stream);
  }

  public getGridStyle(): Record<string, string> {
    const cols = this.streams?.length === 1 ? 1 : this.gridColumns;
    return { 'grid-template-columns': `repeat(${cols}, 1fr)` };
  }
}
